import * as Yup from "yup";

export const initialValues = {
  Nationality: "V",
  Identification: "",
  CardNumber: "",
  recaptcha: null,
};

export const validateForm = Yup.object({
  Nationality: Yup.string().required("El Tipo de Identificación es requerido"),
  Identification: Yup.string()
    .matches(/^[1-9]\d*$/, "El Número de Cédula no es válido")
    .required("El Número de Cédula es requerido")
    .min(5, "El Número de Cédula debe ser mínimo de 5 dígitos"),
  CardNumber: Yup.string().required("El Número de Tarjeta es requerido"),
  recaptcha: Yup.string().required("El Recaptcha es requerido").nullable(),
});
